var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sea-page',{attrs:{"title":"I miei dati","header":"I miei dati"}},[_c('employee-profile',{attrs:{"fetchData":_vm.fetchMyData,"reset":_vm.reset,"data":_vm.myData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }